"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageNotification = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _JoinComponent = require("../JoinComponent.styled");
var _Notification = require("../../Notification");
/**
 * PageNotification component renders notifications for the Join page.
 * @param {Object} notification - Notification object containing message and other properties
 * @param {boolean} noErrorOrWarning - Whether there are no errors or warnings
 * @returns {JSX.Element} The notification component
 */
var PageNotification = exports.PageNotification = function PageNotification(_ref) {
  var notification = _ref.notification,
    _ref$noErrorOrWarning = _ref.noErrorOrWarning,
    noErrorOrWarning = _ref$noErrorOrWarning === void 0 ? false : _ref$noErrorOrWarning;
  return /*#__PURE__*/_react["default"].createElement(_JoinComponent.NotificationComponentWrapper, {
    "data-testid": "join_notification".concat(noErrorOrWarning ? '_success' : '')
  }, notification.message !== '' && /*#__PURE__*/_react["default"].createElement(_Notification.Notification, notification));
};
PageNotification.propTypes = {
  notification: _propTypes.object,
  noErrorOrWarning: _propTypes.bool
};